/**
 * @packageDocumentation
 * @module HackerAPI.User.Sponsor
 */
import { __extends } from "tslib";
import Company from "../../company/company";
import Base from "../../base/base";
/**
 * A data container for things related to a sponsor user
 * @class
 * @extends { HackerAPI.base }
 */
var Sponsor = /** @class */ (function (_super) {
    __extends(Sponsor, _super);
    /**
     * Creates a new sponsor instance
     * @constructor
     * @param sponsor
     */
    function Sponsor(_a) {
        var _b = _a === void 0 ? {} : _a, company = _b.company, personal_email = _b.personal_email, personalEmail = _b.personalEmail, role = _b.role, skills = _b.skills, company_id = _b.company_id, companyId = _b.companyId;
        var _this = _super.call(this) || this;
        /**
         * The company that the sponsor is representing
         * @type { HackerAPI.Company }
         */
        _this.company = (company && new Company(company)) || null;
        /**
         * The ID of the company that the sponsor belongs
         * @type { number }
         */
        _this.companyId = company_id || companyId || null;
        /**
         * @type { string }
         */
        _this.personalEmail = personal_email || personalEmail || null;
        /**
         * @type { string }
         * @todo Make sure this actually is a string
         */
        _this.role = role || null;
        /**
         * What the sponsor is skilled at
         * @type { string[] }
         */
        _this.skills = skills || null;
        return _this;
    }
    return Sponsor;
}(Base));
export default Sponsor;
//# sourceMappingURL=sponsor.js.map